import React from "react";

const CreditUdhar = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>CreditUdhar</h2>
        <p>Content for CreditUdhar page will go here.</p>
      </div>
    </div>
  );
};

export default CreditUdhar;
